module.exports = __webpack_public_path__ + "static/img/logo_new_start.d9d4c30.png";